module.exports = __webpack_public_path__ + "img/wb_detail.f37bf6b.svg";